import { Component, input, output } from '@angular/core';

import { I18nService, TranslatePipe } from '@recruitee/i18n';
import { ButtonComponent, IconComponent, TruncateComponent } from '@recruitee/user-interface';
import { getHumanReadableFileSize } from '@recruitee/utils';

@Component({
  selector: 'tlc-avatar-input',
  standalone: true,
  imports: [ButtonComponent, IconComponent, TruncateComponent, TranslatePipe],
  templateUrl: './avatar-input.component.html',
  styleUrl: './avatar-input.component.less',
})
export class AvatarInputComponent {
  public readonly DEFAULT_MAX_FILE_SIZE = 2097152; // 2MB
  public readonly validMimeTypes = ['image/png', 'image/jpeg', 'image/jpg'];

  public errorMessage: string | undefined;
  public avatarFile: File | null;

  public maxFileSize = input(this.DEFAULT_MAX_FILE_SIZE); // file size limit in bytes
  public avatarChanged = output<File | null>();

  constructor(private i18n: I18nService) {}

  public cacheAvatarImg(files: FileList | null): void {
    const file = files ? files[0] : undefined;
    this.errorMessage = undefined;
    if (!file) return;

    const validType = this.validMimeTypes.includes(file.type);
    const validSize = file.size <= this.maxFileSize();

    if (validType && validSize) {
      this.avatarFile = file;
      this.avatarChanged.emit(file);
    } else {
      this.avatarFile = null;
      this.avatarChanged.emit(null);
      if (!validSize)
        this.errorMessage = this.i18n.translate('tlc.common.errors.image_validation.size', {
          limit: getHumanReadableFileSize(this.maxFileSize()),
          fileSize: getHumanReadableFileSize(file.size),
        });
      if (!validType)
        this.errorMessage = this.i18n.translate('tlc.common.errors.image_validation.type');
    }
  }
}
